import React from 'react'
import { formatedDate } from '../../Helper/constent';

const SaleReturnPrint = ({ saleDetails = {}, products = [], user = {}, isShow = false }) => {

    return (
        <div className={`sale-invoice-container ${!isShow && 'd-none'}`}>
            <div className={`puechaseee-invoice-container`}>
                <center className="d-flex justify-content-center align-items-center">
                    <img src={saleDetails.store_logo_url} alt="Logo" width={120} />
                </center>
                <p className='text-center my-2'>{saleDetails.store_address}</p>
                <div className="sale-invoice-header">
                    <p><span>Invoice Number:</span> <br /> {saleDetails.invoice_number}</p>
                    <p>To : <br /> {saleDetails?.store_name}</p>
                </div>
                <div className="sale-invoice-details">
                    <p><span>Date:</span> <br /> {formatedDate(saleDetails.sale_return_date)}</p>
                    <p><span>Printed by:</span> <br /> {user.user_name}</p>
                </div>
                <div className="sale-product-list">
                    <table>
                        <thead>
                            <tr>
                                <th className='text-start'>Items</th>
                                <th className='text-end'>Qty</th>
                                <th className='text-end'>Price</th>
                                <th className='text-end'>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map((product, index) => (
                                <tr key={index}>
                                    <td className='text-start'>{product.product_name}</td>
                                    <td className='text-end'>{product.stock_qty}</td>
                                    <td className='text-end'>{product.stock_purchase_price}</td>
                                    <td className='text-end'>{product.total_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="sale-invoice-footer py-2">
                    <div><span>SUB TOTAL :</span> Rs {saleDetails.sub_total_amount ?? 0} /-</div>
                    <div className='mb-2'>
                        <span>DISCOUNT :</span> {saleDetails.discount_percentage ?? 0} %
                        <span style={{ float: 'inline-end' }}>
                            (Rs {((saleDetails.sub_total_amount ?? 0) * (saleDetails.discount_percentage ?? 0) / 100).toFixed(2)} /-)
                        </span>
                    </div>
                    <div className='sale-grand-border pt-2'><span>GRAND TOTAL :</span> Rs {saleDetails.grand_total_amount ?? 0} /-</div>
                </div>

            </div>
        </div>
    )
}

export default SaleReturnPrint;
